<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Button Text*: </h4>
            <input  type="text" v-model="ButtonText" @change="save('copyButtonTextJson')" :disabled="!allowEdit" />
            <TranslatedText 
                v-if="$parent.mediaProperty.configuration.copyButtonTextJson && $parent.mediaProperty.configuration.copyButtonTextJson.length > 1"
                :textJson="$parent.mediaProperty.configuration.copyButtonTextJson"
                position="bottom" alignment="start" 
                :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>
        </div>
        <div class="formRow">
            <h4>Sample Text*: </h4>
            <textarea v-model="SampleText" @change="save('textJson')" :disabled="!allowEdit"></textarea>
            <TranslatedText 
                v-if="$parent.mediaProperty.configuration.textJson && $parent.mediaProperty.configuration.textJson.length > 1"
                :textJson="$parent.mediaProperty.configuration.textJson"
                position="bottom" alignment="start" 
                :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>
        </div>
    </div>
    
</template>

<script>
import {data} from '../../shared/data';
import {translation} from '../../shared/translation';
import TranslatedText from '@/components/shared/TranslatedText.vue';

export default {
    name: 'SampleLanguageEdit',
    components: { TranslatedText },
    data: function() {
        return {
            positions: [],
            alignments: []    
        }
    },
    props: {
        allowEdit: Boolean
    },
    computed: {
        ButtonText: {
            get() {
                return translation.getTextForLanguage(this.$parent?.mediaProperty?.configuration?.copyButtonTextJson, this.$parent.mediaProperty.defaultLanguage);
            },
            set(newText) {
                translation.setTextForLanguage(this.$parent.mediaProperty.configuration, this.$parent.mediaProperty.defaultLanguage, 'copyButtonTextJson', newText);
            }
        },
        SampleText: {
            get() {
                return translation.getTextForLanguage(this.$parent?.mediaProperty?.configuration?.textJson, this.$parent.mediaProperty.defaultLanguage);

            },
            set(newText) {
                translation.setTextForLanguage(this.$parent.mediaProperty.configuration, this.$parent.mediaProperty.defaultLanguage, 'textJson', newText);
            }
        },
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                text: '', 
                position: 'right',
                alignment: 'middle',
                useSmartRepositioning: true
            }
        }

        this.positions = await data.getEnumList("ToolTipPositions");
        this.alignments = await data.getEnumList("ToolTipAlignments");
    },
    methods: {
        save: async function(fieldName) {
            if(fieldName && fieldName.endsWith('Json')) {
                if(fieldName === 'copyButtonTextJson' && this.ButtonText.length === 0) {
                    this.$toast.error("Button Text is required");
                    return;
                }

                if(fieldName === 'textJson' && this.SampleText.length === 0) {
                    this.$toast.error("Sample Text is required");
                    return;
                }

                this.$parent.mediaProperty.configuration[fieldName] =
                    await translation.addTranslations(
                            this.$parent.mediaProperty.configuration[fieldName], 
                            translation.getTextForLanguage(this.$parent.mediaProperty.configuration[fieldName], 
                                            this.$parent.mediaProperty.defaultLanguage),
                            this.$parent.mediaProperty.languages, 
                            this.$parent.mediaProperty.defaultLanguage);
            }   

            const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
          
            if(!this.$parent.mediaProperty.id && resp.id) {
                this.$parent.mediaProperty.id = resp.id;
                this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
            }
        },
        addLanguage: async function(lang) {
            await translation.addTranslationToField(this.$parent.mediaProperty.configuration.textJson, lang, this.$parent.mediaProperty.defaultLanguage, true);
            await translation.addTranslationToField(this.$parent.mediaProperty.configuration.copyButtonTextJson, lang, this.$parent.mediaProperty.defaultLanguage, true);
            await this.save();
        },
        deleteLanguage: async function(lang) {
            translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.textJson, lang);
            translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.copyButtonTextJson, lang);
            await this.save();
        }
    }
}

</script>
<style scoped>
    textarea {
        width: 60%;
        height: 8.5em;
    }

    .formRow {
        align-items: unset;
        margin-bottom: 1em;
    }
</style>